import type { EffectCallback} from 'react';
import { useEffect } from 'react';

export default function useComponentDidMount(effect: EffectCallback) {
    useEffect(effect, []);
}
